// import { useHistory } from 'react-router-dom';
import { useMutation } from "@apollo/client";

import { DELETE_GRAPHIC_STAND } from "graphql/mutation/graphic-stand-gql";

// import GraphicPacking from 'components/graphic-packing';
// import GraphicStandConst from '../graphic-stand-const';
import { successNotification, errorNotification } from "components/request-result";



const useMutationGraphicStandDelete = ({ graphicStand, graphicListId }) => {


    // const history = useHistory();

    const [ _setMutationGraphicStandDelete, { loading } ] = useMutation(DELETE_GRAPHIC_STAND,
        {
            update(cache, { data }) {

                const {
                    graphicStandDelete: {
                        label,
                        message
                    }
                } = data;

                // history.push(`${ GraphicPacking.Const.basePath }/${ graphicListId }${ GraphicStandConst.basePath }`)

                cache.evict({
                    id: cache.identify({ id: graphicStand.id, __typename: "GraphicStand" })
                });
                cache.gc();

                successNotification({
                    title: label.toUpperCase(),
                    description: message
                });
            },
            onError(error) {
                errorNotification(error);
            }
        });

    return {
        _setMutationGraphicStandDelete,
        loadingMutationGraphicStandDelete: loading,
    }
};

export default useMutationGraphicStandDelete;